import React from "react";
import { Link } from "react-router-dom";
import { BarChart3, Clock, Headphones, HelpCircle, Film } from "lucide-react";
import { GameBoard } from "../components/GameBoard";
import { istTodayStr, prettyDate } from "../lib/ist";

const QuickBtn = ({ to, onClick, icon: Icon, label, testid }) => {
  const cls =
    "flex flex-col items-center justify-center gap-2 p-4 ac-card hover:border-amber-400/50 hover:scale-[1.03] transition-all group";
  const inner = (
    <>
      <Icon className="w-6 h-6 ac-gold-text group-hover:scale-110 transition-transform" />
      <span className="text-xs font-bold tracking-wide text-zinc-300 text-center">{label}</span>
    </>
  );
  return to ? (
    <Link to={to} data-testid={testid} className={cls}>{inner}</Link>
  ) : (
    <button onClick={onClick} data-testid={testid} className={cls}>{inner}</button>
  );
};

const DialogueTeaser = null; // removed from UI

export const Home = ({ onHowToPlay }) => {
  const today = istTodayStr();
  return (
    <div className="max-w-2xl mx-auto px-4 sm:px-6 py-8 space-y-8">
      {/* hero */}
      <div className="text-center ac-fade-up">
        <div className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.3em] text-zinc-500 mb-3">
          <Film className="w-4 h-4 ac-gold-text" /> Daily Movie Guessing Game
        </div>
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-black tracking-tight ac-gold-text drop-shadow-[0_2px_20px_rgba(229,169,60,0.25)]">
          ABSOLUTE CINEMA
        </h1>
        <div className="mt-4 inline-block px-4 py-1.5 rounded-full bg-amber-500/10 border border-amber-500/25">
          <span className="text-xs uppercase tracking-[0.25em] text-amber-200">
            Today's Movie · {prettyDate(today)}
          </span>
        </div>
      </div>

      {/* quick actions */}
      <div className="grid grid-cols-3 gap-3">
        <QuickBtn to="/stats" icon={BarChart3} label="STATS" testid="home-stats-btn" />
        <QuickBtn to="/time-machine" icon={Clock} label="TIME MACHINE" testid="home-timemachine-btn" />
        <QuickBtn onClick={onHowToPlay} icon={HelpCircle} label="HOW TO PLAY" testid="home-howtoplay-btn" />
      </div>

      {/* the game */}
      <GameBoard backendMode="daily" storageMode="daily" date={today} modeLabel="DAILY MOVIE" />
    </div>
  );
};
